import type { EditorSnapshot } from '../types/scene'
import { deepClone } from '../utils/deepClone'

export class HistoryManager {
  private undoStack: EditorSnapshot[] = []
  private redoStack: EditorSnapshot[] = []
  private readonly MAX_STEPS = 50

  push(snapshot: EditorSnapshot) {
    this.undoStack.push(deepClone(snapshot))
    if (this.undoStack.length > this.MAX_STEPS) this.undoStack.shift()
    this.redoStack = []
  }

  undo(current: EditorSnapshot): EditorSnapshot | null {
    if (this.undoStack.length === 0) return null
    this.redoStack.push(deepClone(current))
    return deepClone(this.undoStack.pop()!)
  }

  redo(current: EditorSnapshot): EditorSnapshot | null {
    if (this.redoStack.length === 0) return null
    this.undoStack.push(deepClone(current))
    return deepClone(this.redoStack.pop()!)
  }

  canUndo() { return this.undoStack.length > 0 }
  canRedo() { return this.redoStack.length > 0 }
  clear() { this.undoStack = []; this.redoStack = [] }
}
